import { Link } from "react-router-dom";
import heroFallback640 from "@/assets/hero-fallback-640.webp";
import heroFallback1024 from "@/assets/hero-fallback-1024.webp";
import heroFallback1600 from "@/assets/hero-fallback-1600.webp";
import heroFallback640Avif from "@/assets/hero-fallback-640.avif";
import heroFallback1024Avif from "@/assets/hero-fallback-1024.avif";
import heroFallback1600Avif from "@/assets/hero-fallback-1600.avif";

const HeroSection = () => {
  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      <picture>
        <source
          type="image/avif"
          srcSet={`${heroFallback640Avif} 640w, ${heroFallback1024Avif} 1024w, ${heroFallback1600Avif} 1600w`}
          sizes="100vw"
        />
        <source
          type="image/webp"
          srcSet={`${heroFallback640} 640w, ${heroFallback1024} 1024w, ${heroFallback1600} 1600w`}
          sizes="100vw"
        />
        <img
          src={heroFallback1024}
          alt=""
          aria-hidden
          fetchPriority="high"
          decoding="async"
          width={1920}
          height={1080}
          className="absolute inset-0 h-full w-full object-cover"
        />
      </picture>

      <div
        className="absolute inset-0"
        style={{ background: "var(--hero-overlay)" }}
      />

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
        <p
          className="font-body text-xs font-medium uppercase tracking-[0.35em] text-accent-foreground opacity-0 animate-fade-up"
          style={{ animationDelay: "0.3s" }}
        >
          San Diego, California
        </p>

        <h1
          className="font-display mt-5 text-5xl font-semibold leading-tight text-accent-foreground opacity-0 animate-fade-up sm:text-7xl md:text-8xl lg:text-9xl"
          style={{ animationDelay: "0.6s" }}
        >
          San Diego
          <br />
          <span className="italic">Coast</span> Guide
          <span className="mt-4 block font-body text-lg font-light not-italic tracking-wide sm:text-2xl">
            Your Complete Guide to Beaches, Surf, and Tides
          </span>
        </h1>

        <p
          className="font-body mt-6 max-w-xl rounded-2xl bg-black/40 px-6 py-3 text-base font-light leading-relaxed text-accent-foreground backdrop-blur-sm opacity-0 animate-fade-up sm:text-lg"
          style={{ animationDelay: "0.9s" }}
        >
          Local guides to the San Diego coast — beaches, live tides, surf, dining, trails, and coastal events from Imperial Beach to Oceanside.
        </p>

        <div
          className="mt-10 flex gap-4 opacity-0 animate-fade-up"
          style={{ animationDelay: "1.2s" }}
        >
          <Link
            to="/beaches"
            className="inline-flex h-12 items-center rounded-md bg-accent px-8 font-body text-xs font-medium uppercase tracking-wide text-accent-foreground hover:bg-accent/90 transition-colors"
          >
            Explore
          </Link>
        </div>

        <div
          className="mt-5 flex flex-wrap justify-center gap-3 opacity-0 animate-fade-up"
          style={{ animationDelay: "1.5s" }}
        >
          {[
            { emoji: "🏖", label: "Plan a Beach Day", to: "/beaches" },
            { emoji: "🌊", label: "Check Surf", to: "/surf" },
            { emoji: "🌙", label: "Check Tides", to: "/tides" },
            { emoji: "🍽", label: "Find Food & Drinks", to: "/dining" },
          ].map((pill) => (
            <Link
              key={pill.label}
              to={pill.to}
              className="inline-flex items-center gap-2 rounded-full border border-accent-foreground/30 bg-accent-foreground/10 px-4 py-1.5 font-body text-xs text-accent-foreground backdrop-blur-sm transition-colors hover:bg-accent-foreground/15"
            >
              <span className="text-xl leading-none" aria-hidden="true">{pill.emoji}</span>
              {pill.label}
            </Link>
          ))}
        </div>
      </div>

      <div
        className="absolute bottom-8 left-1/2 -translate-x-1/2 opacity-0 animate-fade-in"
        style={{ animationDelay: "2s" }}
      >
        <div className="flex flex-col items-center gap-2">
          <span className="font-body text-[10px] uppercase tracking-[0.3em] text-accent-foreground">
            Scroll
          </span>
          <div className="h-10 w-px bg-accent-foreground/30" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
